import { render } from "./UgmMachineList.vue?vue&type=template&id=23945828&scoped=true"
import script from "./UgmMachineList.vue?vue&type=script&lang=js"
export * from "./UgmMachineList.vue?vue&type=script&lang=js"

import "./UgmMachineList.vue?vue&type=style&index=0&id=23945828&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23945828"]])

export default __exports__